<template>
  <div class="loginContent">
    <!-- pc -->
    <div v-show="this.isApp == true ? false : true">
      <transition name="login-con">
      <div class="popBack" v-show="isLoginShow">
             <div class="login_pop">
      <div class="login_guanbi subb" @click="changeLogin">
        <i class="el-icon-error"></i>
      </div>
      <div class="login_title">{{$t('login.login')}}</div>
      <div class="login_msg">
        <div class="login_com">
          <div class="login_as">{{$t('login.account')}}</div>
          <div class="login_input">
            <input type="text" :placeholder="this.$t('login.enter')" v-model="phone" />
          </div>
        </div>
        <div class="login_com">
          <div class="login_as">{{$t('login.password')}}</div>
          <div class="login_input">
            <input type="password" :placeholder="this.$t('login.enter')" v-model="password" />
          </div>
        </div>
        <div class="error" v-show="isError">{{$t('login.error')}}</div>
        <div class="login_in" @click="getUserLogin">{{$t('login.login')}}</div>
      </div>
    </div>
      </div>
    </transition>
    </div>
    <!-- H5 -->
    <div class="" v-show="this.isApp == false ? false : true">
      <transition name="login-con-h5">
        <div class="popBack" v-show="isLoginShow">
                   <div class="h5_login_pop">
      <div class="login_guanbi subb" @click="changeLogin">
        <i class="el-icon-error"></i>
      </div>
      <div class="login_title">{{$t('login.login')}}</div>
      <div class="h5_login_msg">
        <div class="login_com">
          <div class="login_as">{{$t('login.account')}}</div>
          <div class="h5_login_input">
            <input type="text" :placeholder="this.$t('login.enter')" v-model="phone" />
          </div>
        </div>
        <div class="login_com">
          <div class="login_as">{{$t('login.password')}}</div>
          <div class="h5_login_input">
            <input type="password" :placeholder="this.$t('login.enter')" v-model="password" />
          </div>
        </div>
        <div class="login_in" @click="getUserLogin">{{$t('login.login')}}</div>
      </div>
    </div>
      </div>
      </transition>
    </div>
    <div>
    </div>
    <My-popup 
				:popupMsg = "popupMsg" 
				@handlePopup='handleShowOrHidePopup'
				v-show="showPopup"/>
    <router-view></router-view>
  </div>
</template>

<script>
import myPopup from '../components/myPopup.vue';
import { mapActions, mapState, mapMutations } from "vuex";
import "../assets/h5/login.css";
export default {
  components: {myPopup},
  data() {
    return {
      isError:false,
      phone:'60173972155',
      password:'aa123123',
      // phone:'',
      // password:'',
      isLoginShow: false,
      showPopup:false,
      popupMsg:{
									title:'',
									content:'',
									// cancel:'取消',
									confirm:'ok'
				},
    };
  },
  computed:{
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
      hasLogin(state) {
        return state.hasLogin;
      },
    }),
  },
  mounted() {
    document.addEventListener("click", (e) => {
      // console.log('e.target.className',e.target.className)
      if (e.target.className == "popBack") {
        this.isLoginShow = false;
      }
    });
  },
  methods: {
    ...mapMutations(['login']),
		goUser(provider){
        // console.log('provider----',provider)
				this.login(provider)
      // location.reload();
		},
    getUserLogin(){
				var _that = this
        if(_that.phone!=''&&_that.password!=''&&_that.phone!=null&&_that.password!=null){
          _that.showPopup=true
          _that.isError=false
          // console.log('1')
				  let obj = {
				         phone_num: _that.phone,
				         password:_that.password
				        };
				        this.$FucPost(this.$store.state.ip + "/login", obj)
				          .then(function (res) {
				            // console.log('res',res)
                    let data = res.msg
				             _that.$store.commit("setToken",res.token)
                     if(res.code =='200'){
                      //  console.log('123')
                      //  _that.$store.commit("setToken",res.token)
                        _that.showPopup=false
                        // _that.popupMsg.content = res.msg
                        _that.goUser(data)
                        // location.reload()
                     }else{
                        _that.showPopup=true
                        _that.popupMsg.content = res.msg
                     }
                     _that.isLoginShow = false
				          })
				          .catch((err) => {
				            console.log(err);
				          });
        }else{
          _that.isError=true
        }
			}, 
    changeLogin() {
      this.isLoginShow = false;
      if(this.hasLogin==false){
          if(this.$route.path=="/Buy"||this.$route.path=="/Gift"||this.$route.path=="/Vip"){
             this.$router.push("/")
             this.$store.commit("setActive", -1);
             this.$store.commit("setShow", true);
      }
      }
    },
    showLogin() {
      this.isLoginShow = true;
    },
    handleShowOrHidePopup:function(type){
							if(type=='yes'){
								// console.log(type)
								this.showPopup = false
                // location.reload();
							}else{
								// console.log(type)
								this.showPopup = false
                // location.reload();
							}
						},
  },
};
</script>
<style lang="less" scoped>
.popBack{
    width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.685);
		z-index: 8888;
}
.login_pop {
  z-index: 9999;
  position: relative;
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 25rem;
  height: 15.625rem;
  background-color: black;
  border: 0.125rem solid #e1aa3f;
  border-top: none;
  border-radius: 1.25rem;
// background: #ebce94;
box-shadow:  0.5625rem 0.5625rem 1.125rem #c99e48,
             -0.5625rem -0.5625rem 1.125rem #ffd662;
}

.login_title {
  background: #ffdb6b;
  background-image: linear-gradient(
    180deg,
    #dea339 0%,
    #f9cc4a 20%,
    #ffdb6b 35%,
    #ffdb6b 55%,
    #ce9631 80%,
    #8c5c0d 100%
  );
  color: #2e0100;
  font-weight: 700;
  font-size: 1.25rem;
  height: 2.25rem;
  line-height: 2.25rem;
}
.login_msg {
  width: 23.75rem;
  background-color: rgb(60, 0, 0);
  height: 12.5rem;
  margin: 0 auto;
}
.login_com {
  padding-top: 1.875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: center;
  margin-left: 1.5625rem;
}
.login_as {
  width: 20%;
  color: #f9cc4a;
  margin-right: 0.625rem;
}
.login_input input {
  height: 1.875rem;
  width: 13rem;
}
.login_in {
  color: #000;
  background-image: linear-gradient(
    #d5ff70 0%,
    #3b8c00 50%,
    #358000 50%,
    #296100 90%,
    #1e4600 100%
  );
  border: 0.125rem solid #a2750a;
  font-size: 1.125rem;
  padding: 0.375rem 0rem;
  font-weight: 600;
  width: 9.375rem;
  margin: 0 auto;
  margin-top: 1rem;
  border-radius: 0.3125rem;
}
.login_guanbi {
  position: absolute;
  top: -0.9375rem;
  right: -0.9375rem;
  .el-icon-error {
    font-size: 1.8rem;
    color: white;
    border: 0.125rem solid white;
    border-radius:50%;
    background-color: #000;
  }
}
.error{
  margin: 0.3125rem auto;
  font-size: 1rem;
  color: red;
}

.login-con-enter-active, .login-con-leave-active {
    transition: opacity .5s;
  }
  .login-con-enter, 
  .login-con-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
.login-con-h5-enter-active, .login-con-h5-leave-active {
    transition: opacity .5s;
  }
  .login-con-h5-enter, 
  .login-con-h5-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
<style>
  @keyframes rotBGimg {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>